// Evertreen-Daten live von xcon.at API holen.
// Bei Fehler bleiben die statischen Defaults im Liquid-Markup sichtbar.
(function () {
  function fmtTrees(v) {
    var n = parseInt(String(v).replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? null : n.toLocaleString('de-DE');
  }
  // CO2: API liefert EN-Format ("1,028t" = 1.028 t). Tausender- und
  // Dezimaltrenner erkennen, dann DE-Format ausgeben ("1.028t", "454,7t").
  function fmtCo2(v) {
    var s = String(v == null ? '' : v).trim().replace(/\s*t$/i, '');
    if (!s) return null;
    var n;
    if (/^\d{1,3}([.,]\d{3})+$/.test(s)) n = parseInt(s.replace(/[.,]/g, ''), 10);
    else if (/^\d{1,3}(,\d{3})+\.\d+$/.test(s)) n = parseFloat(s.replace(/,/g, ''));
    else if (/^\d{1,3}(\.\d{3})+,\d+$/.test(s)) n = parseFloat(s.replace(/\./g, '').replace(',', '.'));
    else if (/^\d+([.,]\d+)?$/.test(s)) n = parseFloat(s.replace(',', '.'));
    else return null;
    return isNaN(n) ? null : n.toLocaleString('de-DE', { maximumFractionDigits: 1 }) + 't';
  }
  function fmtCountries(v) {
    var n = parseInt(String(v).replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? null : String(n);
  }
  var fmt = { trees: fmtTrees, co2: fmtCo2, countries: fmtCountries };

  fetch('https://www.xcon.at/api/evertreen', { cache: 'default' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data) return;
      Object.keys(fmt).forEach(function (key) {
        var els = document.querySelectorAll('[data-evertreen="' + key + '"]');
        var val = fmt[key](data[key]);
        if (!val) return;
        els.forEach(function (el) { el.textContent = val; });
      });
    })
    .catch(function () { /* silent */ });
})();
